<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="英文名" 
    sub_label="Given name"
    innerValue="{{innerValue}}"
    nameTips="{{nameTips}}"
    isDisable="{{isEnNameDisable}}"
  >
    <input
      fixed
      class="es-content__input"
      wx:model="{{ innerValue }}"
      type="text"
      placeholder='如王大庆填写为“DAQING”'
      bindblur="englishNameBoxBlur"
      slot="input"
    />
  </from-item>

</template>

<script>
import { watch } from "@mpxjs/core";

  import { createComponent } from '@didi/es-mpx-creator'
  import { checkEnglishName, checkEnglishNameLength, hasRequired } from '@/utils'
  createComponent({
    classes: [],
    data: {
      innerValue:''
    },
    props: {
      value:{
        type: String,
        value: ''
      },
      // hasRequired:{
      //   type: Boolean,
      //   value: true
      // },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow: {
        type: Boolean,
        value: false
      },
      isNameDisable:{
        type: Boolean,
        value: false
      },
      englishSurname:String,
      item:Object,
      selectedCardList:Array,
      isEnNameDisable:Boolean,
      isNeedCard:Boolean,
      
    },
    computed: {
      nameTips() {
        let allName = this.innerValue + this.englishSurname
        return this.innerValue?(
          checkEnglishName(this.innerValue) || checkEnglishNameLength(allName) || '' 
          ) : ''
      },
      isRequired() {
        // TODO: 删除多余代码,hasRequired函数的返回值可统一由外部传入
        let selectedCardList = []
        if(this.isNeedCard){
          selectedCardList = this.selectedCardList
        }
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      }
    },
    methods: {
      englishNameBoxBlur(e) {
        let value = e?.detail?.value || ''
        setTimeout(() => {
          this.innerValue = (value + '').toUpperCase()
        }, 100)
      },
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
    },
    mounted() {
      this.innerValue = this.value
    }
  })
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('input')
      width calc(100% - 6px)
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item'
    }
  }
</script>

